import { render, staticRenderFns } from "./StudentStatement.vue?vue&type=template&id=223f1858"
import script from "./StudentStatement.vue?vue&type=script&lang=js"
export * from "./StudentStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports